import { render, staticRenderFns } from "./ConvenioDelete.vue?vue&type=template&id=c4fa27c2"
import script from "./ConvenioDelete.vue?vue&type=script&lang=js"
export * from "./ConvenioDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports